import Vue from 'vue'
import VueRouter from 'vue-router'
import loginRoutes from "./modules/login";
import maindata from "./modules/maindata";
import systemdata from "./modules/systemdata";
import showDocRoutes from "./modules/showdoc";
import express from "./modules/express";
import rule from "./modules/rule";
import home from "./modules/home";
import report from "./modules/report";


export const allRoutes = [
  ...loginRoutes,
  ...maindata,
  ...systemdata,
  ...express,
  ...rule,
  ...home,
  ...showDocRoutes,
  ...report

]

// 去除路由重复警告
const originalPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

function createRouter(routes) {
  return new VueRouter({
    mode: 'hash',
    scrollBehavior: () => ({y: 0}),
    routes
  })
}

const router = createRouter(allRoutes)
export default router




// WEBPACK FOOTER //
// ./src/router/index.js